import { Component } from '@angular/core';
import { ISelectOption } from '@lsq-frontend/common-ui';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { SupportedBankCountry, SupportedBankTransferType } from '../../../constants/bank.constants';
import { AddBankAccountFormService } from './add-bank-account-form.service';
import { AddIntlBankAccountFormService } from './add-intl-bank-account-form.service';
import { BankAccountFormControllerService } from './bank-account-form-controller.service';
import { SupportedBankPaymentMethod } from './bank-accounts.models';

@Component({
    selector: 'add-bank-account-controller',
    template: `
        <div class="add-bank-account-controller">
            <p
                [style.padding-top]="'0'"
                class="body"
                [style.line-height]="'2rem'"
                [style.padding-bottom]="'2rem'"
                i18n
            >
                Where should we send your payments? Please enter the information for the payment
                method you’d like to use to receive payment.
            </p>
            <lsq-select
                class="country-select"
                label="Select a Location"
                [options]="bankPaymentOptions"
                [innerLabel]="true"
                name="country"
                [(ngModel)]="bankPaymentMethod"
                (ngModelChange)="updateBankPaymentMethod($event)"
            >
            </lsq-select>
            <add-bank-account-form
                *ngIf="
                    bankPaymentMethod &&
                    bankPaymentMethod.country === unitedStatesEnum &&
                    bankPaymentMethod.transferType !== wireEnum
                "
            ></add-bank-account-form>
            <add-intl-bank-account-form
                *ngIf="bankPaymentMethod && bankPaymentMethod.transferType === wireEnum"
                [bankPaymentMethod]="bankPaymentMethod"
            ></add-intl-bank-account-form>
        </div>
    `
})
export class AddBankAccountControllerComponent {
    public unitedStatesEnum = SupportedBankCountry.UNITED_STATES;
    public wireEnum = SupportedBankTransferType.WIRE;

    public bankPaymentOptions: ISelectOption[] = [
        {
            label: this._i18n('United States (ACH)'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.UNITED_STATES,
                transferType: SupportedBankTransferType.ACH
            })
        },
        {
            label: this._i18n('United States (Wire)'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.UNITED_STATES,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('China'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.CHINA,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('Vietnam'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.VIETNAM,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('Malaysia'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.MALAYSIA,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('Taiwan'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.TAIWAN,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('Hong Kong'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.HONG_KONG,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('India'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.INDIA,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('Thailand'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.THAILAND,
                transferType: SupportedBankTransferType.WIRE
            })
        },
        {
            label: this._i18n('Canada'),
            value: new SupportedBankPaymentMethod({
                country: SupportedBankCountry.CANADA,
                transferType: SupportedBankTransferType.WIRE
            })
        }
    ];
    public bankPaymentMethod: SupportedBankPaymentMethod;

    constructor(
        public addIntlBankAccountFormService: AddIntlBankAccountFormService,
        public addBankAccountFormService: AddBankAccountFormService,
        public bankAccountFormControllerService: BankAccountFormControllerService,
        private _i18n: I18n
    ) {}

    public updateBankPaymentMethod(value: SupportedBankPaymentMethod): void {
        if (value) {
            this.bankAccountFormControllerService.setBankPaymentMethod(value);
        }
    }
}
